<template>
    <span>
        <span @click="getExtraInfo">
            <i :title="this.$lang('Dodatkowe informacje o bibliotece')"
               class="fa fa-asterisk mr-3 my-auto" :style="{verticalAlign: 'middle', cursor: 'pointer', visibility: (visible) ? 'visible' : 'hidden'}"
               data-toggle="modal" data-target="#show-extra-info-modal"></i>
        </span>
    </span>
</template>

<script>
import {EventBus} from "../../mixins/event-bus";

export default {
    name: "library-extra-info",
    props: {
        library_id: Number | String,
        get_extra_info_route: String,
        visible: Number,
    },
    data() {
        return {
            extraInfo: null,
        }
    },
    methods: {
        getExtraInfo() {
            let self = this;

            EventBus.$emit('libraryExtraInfo', {
                libraryName: null,
                extraInfo: null,
            });

            axios.get(self.get_extra_info_route).then(response => {
                self.libraryName = response.data.libraryName;
                if (response.data.extraInfo === '') {
                    self.extraInfo = 'Brak dodatkowych informacji o bibliotece.';
                } else {
                    self.extraInfo = response.data.extraInfo;
                }
            }).catch(error => {
                console.log('Error: '+error);
                self.libraryName = this.$lang('');
                self.extraInfo = this.$lang('Nie udało się pobrać informacji.');
            }). finally(function (){
                EventBus.$emit('libraryExtraInfo', {
                    libraryName: self.libraryName,
                    extraInfo: self.extraInfo,
                });
            });
        },
    }
}
</script>

<style scoped>

</style>
